import { IActivity, EnActivityMode, EnShift } from '@medlogic/shared/shared-interfaces';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { IActivityState } from './activity-state';

import * as ActivityActions from './activity.actions';

export const activityFeatureKey = 'activity';


export const adapterActivity: EntityAdapter<IActivity> = createEntityAdapter<IActivity>({
  selectId: instance => instance.activityIdentifier,
  sortComparer: sortOnOcurrencyAndNames
});

export const initialStateActivity: IActivityState = adapterActivity.getInitialState({
  // additional entity state properties
  activityTypes: null,
  error: undefined,
  selectedId: null,
  selectedActivityMode: EnActivityMode.CarePlan,
  selectedShift: EnShift.all,
  selectedCrud: null,
  selectedActivityType: null
});

// FIXME: Falta incluir regras de negócio de ordenação para os alertas
function usersSortFn(a: IActivity, b: IActivity) {
  return a?.activityName.localeCompare(b?.activityName); //TODO: Validar se estes parâmetros estão corretos
}

function sortOnOcurrencyAndNames(a: IActivity, b: IActivity) {
  if (a.medlogicId === b.medlogicId) {
    return a.activityName < b.activityName ? -1 : 1; //TODO: Validar se estes parâmetros estão corretos
  } else {
    return a.medlogicId ? -1 : 1;
  }
}

export const reducer = createReducer(
  initialStateActivity,
  on(ActivityActions.addActivity,
    (state, action) => adapterActivity.addOne(action.activity, state)
  ),
  on(ActivityActions.setShift,
    (state, action) => ({ ...state, selectedShift: action.shift })
  ),
  on(ActivityActions.setCrud,
    (state, action) => ({ ...state, selectedId: null, selectedCrud: action.crud, selectedActivityType: action.activityType })
  ),
  on(ActivityActions.setActivity,
    (state, action) => ({ ...state, selectedId: action.selectedId })
  ),
  on(ActivityActions.setActivityType,
    (state, action) => ({ ...state, selectedActivityType: action.selectedActivityType })
    ),
  on(ActivityActions.upsertActivity,
    (state, action) => adapterActivity.upsertOne(action.activity, state)
  ),
  on(ActivityActions.addActivities,
    (state, action) => adapterActivity.addMany(action.activities, state)
  ),
  on(ActivityActions.upsertActivities,
    (state, action) => adapterActivity.upsertMany(action.activities, state)
  ),
  on(ActivityActions.updateActivity,
    (state, action) => adapterActivity.updateOne(action.activity, state)
  ),
  on(ActivityActions.updateActivities,
    (state, action) => adapterActivity.updateMany(action.activities, state)
  ),
  on(ActivityActions.deleteActivity,
    (state, action) => adapterActivity.removeOne(action.id, state)
  ),
  on(ActivityActions.deleteActivities,
    (state, action) => adapterActivity.removeMany(action.ids, state)
  ),
  on(ActivityActions.loadActivitiesSuccess,
    // upsertMany é problemático, pois, caso haja pacientes excluídos, permaneceriam
    // (state, action) => adapterActivity.upsertMany(action.activities, state)
    (state, action) => adapterActivity.setAll(action.activities, state)
  ),
  on(ActivityActions.activityFail,
    (state, action) => ({
      ...state,
      error: action?.error
    })
  ),
  on(ActivityActions.loadActivityTypesSuccess,
    (state, action) => ({
      ...state,
      activityTypes: action?.activityTypes || null
    })
  ),
  on(ActivityActions.activityTypesFail,
    (state, action) => ({
      ...state,
      activityTypes: null
    })
  ),
  on(ActivityActions.clearActivities,
    state => initialStateActivity
  ),
  on(ActivityActions.clearSelectedActivity,
    state => ({ ...state, selectedId: null })
  ),
  on(ActivityActions.loadActivities,
    state => ({ ...state })
  ),

  on(ActivityActions.setActivityMode,
    (state, action) => ({ ...state, selectedActivityMode: action.selectedActivityMode })
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapterActivity.getSelectors();


export const getSelectedId = (state: IActivityState) => state.selectedId;
export const getSelectedActivityMode = (state: IActivityState) => state.selectedActivityMode;
